import $http from '../../../axios';
import {MessageBox, Notification} from 'element-ui';
import {setApprovalStates, setDocuments, setDocumentsByThread} from './mutations';

export async function fetchDocuments({commit}) {

    const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

    let params = {
        warehouse_id: user_b2b.id
    };

    commit('setPreloader', true);

    await $http.get('/api/documentos-por-sucursal-cliente', {params})
        .then((response) => {
            commit('setDocuments', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener las solicitudes',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function fetchRequestTypes({commit}) {
    await $http
        .get('/api/parametros-por-codigo/RTGM')
        .then(response => {
            commit('setRequestTypes', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchDevolutionReasons({commit}) {
    await $http
        .get('/api/parametros-por-codigo/136')
        .then(response => {
            commit('setDevolutionReasons', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchGuaranteeReasons({commit}) {
    await $http
        .get('/api/parametros-por-codigo/DRGM')
        .then(response => {
            commit('setGuaranteeReasons', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchApprovalStates({commit}) {
    await $http
        .get('/api/parametros-por-codigo/GAS01')
        .then(response => {
            commit('setApprovalStates', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchApprovalReasons({commit}) {
    await $http
        .get('/api/parametros-por-codigo/GAR01')
        .then(response => {
            commit('setApprovalReasons', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchOptions({commit}) {
    await $http
        .get('/api/parametros-por-codigo/PGOP')
        .then(response => {
            commit('setOptions', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchModel({commit}) {
    await $http
        .get('/api/modelo-por-codigo/155')
        .then(response => {
            commit('setModel', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function findAll({commit, state, dispatch}, reset_page = false) {

    if (reset_page) {
        commit('resetPageFilters');
    }

    const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

    commit('setContactWarehouseIdRequestGuaranteeFilters', user_b2b.id);
    commit('setPreloader', true);

    await $http.get('/api/solicitud-de-garantia', {params: state.filters})
        .then((response) => {
            commit('setRequestsGuarantees', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener las solicitudes',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function create({commit, state, dispatch}) {
    commit('setSending', true);
    commit('setPreloader', true);

    const user_b2b = JSON.parse(localStorage.getItem('user_b2b'));

    commit('setContactWarehouseIdRequestGuarantee', user_b2b);

    let request_guarantee = JSON.parse(JSON.stringify(state.request_guarantee));

    request_guarantee.model_id = state.model.id;
    request_guarantee.vouchertype_id = state.model.voucherType_id;

    state.documents.map(d => {
        if (d.id === request_guarantee.invoice_id) {
            request_guarantee.branchoffice_warehouse_id = d.branchoffice_warehouse_id;
        }
    });

    await $http.post('/api/solicitud-de-garantia', request_guarantee)
        .then(async (response) => {

            commit('setRequestGuarantee', response.data.data);

            commit('setSending', false);
            commit('setPreloader', false);

            commit('setStep', 1);
            commit('setStepAvailable', 1);

            Notification.success({
                title: 'Éxito!',
                message: 'Solicitud creada correctamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al crear la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function update({commit, state, dispatch}, files) {

    let keys = [
        'images_product',
        'other_images',
        'images_guide'
    ];

    let form_data = new FormData();

    for (const property in state.request_guarantee) {
        if (property !== 'attachments_deleted' && !['images_product_loaded', 'other_images_loaded', 'images_guide_loaded'].includes(property)) {
            form_data.append(property, state.request_guarantee[property]);
        }
    }

    keys.map(key => {
        if (files[key]) {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        }
    });

    for (let i = 0; i < state.request_guarantee.attachments_deleted.length; i++) {
        form_data.append('attachments_deleted[' + i + ']', state.request_guarantee.attachments_deleted[i].id);
    }

    form_data.append('documents_products', JSON.stringify(state.request_guarantee.return.documents_products));

    await $http.post('/api/solicitud-de-garantia/' + state.request_guarantee.id, form_data)
        .then((response) => {
            dispatch('findAll');
            commit('setModalShow', false);
            commit('resetRequestGuarantee');
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.success({
                title: 'Éxito!',
                message: 'Solicitud actualizada correctamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al actualizar la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function findForId({commit, state, dispatch}, id) {

    commit('setPreloader', true);

    await $http.get('/api/solicitud-de-garantia/' + id)
        .then((response) => {

            let request_guarantee = response.data.data;

            request_guarantee.return.documents_products.map(dp => {

                if (dp.requested_quantity === null) {
                    let _dpi = request_guarantee.invoice.documents_products.find(dpi => dpi.product_id === dp.product_id);

                    if (_dpi) {
                        dp.requested_quantity = _dpi.quantity;
                    }
                }

                if (dp.received_quantity === null) {
                    dp.received_quantity = dp.requested_quantity;
                }

                if (dp.authorized_quantity === null) {
                    dp.authorized_quantity = dp.received_quantity;
                }

            });

            commit('setRequestGuarantee', request_guarantee);

            let step = 1;
            let action = 'Editar';

            if (state.request_guarantee.request_guarantee_state && state.request_guarantee.request_guarantee_state.state) {

                let step_code = state.request_guarantee.request_guarantee_state.state.code_parameter;

                let step_obj = state.steps.find(s => s.code === step_code);

                if (step_obj) {
                    step = step_obj.step;
                }

                let type = state.request_types.find(t => t.id === state.request_guarantee.type_id);

                if (step_code === 'PGS5' && type && type.code_parameter === 'RTGM02') {
                    step++;
                }
            }


            commit('setStep', step);
            commit('setAction', action);
            commit('setStepAvailable', step);
            commit('setPreloader', false);

        }).catch((error) => {

            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al obtener la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function updateWithNewState({commit, state, dispatch}, files) {
    commit('setSending', true);
    commit('setPreloader', true);

    let keys = [
        'images_product',
        'other_images',
        'images_guide'
    ];

    let form_data = new FormData();

    for (const property in state.request_guarantee) {
        if (property !== 'attachments_deleted' && !['images_product_loaded', 'other_images_loaded', 'images_guide_loaded'].includes(property)) {
            form_data.append(property, state.request_guarantee[property]);
        }
    }

    keys.map(key => {
        if (files[key]) {
            for (let i = 0; i < files[key].length; i++) {
                form_data.append(key + '_loaded[' + i + ']', files[key][i]);
            }
        }
    });

    for (let i = 0; i < state.request_guarantee.attachments_deleted.length; i++) {
        form_data.append('attachments_deleted[' + i + ']', state.request_guarantee.attachments_deleted[i].id);
    }

    form_data.append('documents_products', JSON.stringify(state.request_guarantee.return.documents_products));

    await $http.post('/api/solicitud-de-garantia/nuevo-estado/' + state.request_guarantee.id, form_data)
        .then(async (response) => {
            await dispatch('findAll');
            commit('setModalShow', false);
            commit('resetRequestGuarantee');
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.success({
                title: 'Éxito!',
                message: 'Solicitud actualizada correctamente',
                type: 'success',
                duration: 3000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            commit('setSending', false);
            commit('setPreloader', false);

            Notification.error({
                title: 'Error',
                message: 'Error al actualizar la solicitud',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}

export async function finalizeRequestGuarantee({commit, state, dispatch}) {
    commit('setSending', true);
    commit('setPreloader', true);

    return new Promise(async (resolve, reject) => {
        await $http.post('/api/solicitud-de-garantia/finalizar/' + state.request_guarantee.id, state.request_guarantee)
            .then(async (response) => {
                commit('setModalShow', false);
                commit('resetRequestGuarantee');
                commit('setSending', false);
                commit('setPreloader', false);
                commit('setShowToModalPdf', response.data.data.data);

                Notification.success({
                    title: 'Éxito!',
                    message: 'Solicitud finalizada correctamente',
                    type: 'success',
                    duration: 3000,
                    customClass: 'notification-box',
                });

                resolve(response.data.data.data);
            }).catch((error) => {
                commit('setSending', false);
                commit('setPreloader', false);

                Notification.error({
                    title: 'Error',
                    message: 'Error al actualizar la solicitud',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });
                reject();
            });
    });
}

export async function deleteAttachment({commit, state}, attachment) {
    await MessageBox.confirm('¿Está seguro de eliminar el adjunto?', 'Eliminar adjunto', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        customClass: 'notification-danger'
    }).then(async (result) => {
        commit('addAttachmentDeleteRequestGuarantee', attachment);
        commit('deleteAttachmentRequestGuarantee', attachment);
    }).catch((e) => {
        console.error(e);
    });
}

export async function destroy({commit, state, dispatch}, request_guarantee) {

    if (!request_guarantee.only_view) {
        await MessageBox.confirm('¿Está seguro de cancelar la solicitud?', 'Cancelar', {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            customClass: 'notification-danger'
        }).then(async (result) => {

            commit('setPreloader', true);

            await $http.delete('/api/solicitud-de-garantia/' + request_guarantee.id)
                .then(async (response) => {
                    await dispatch('findAll');
                    commit('setPreloader', false);
                    Notification.success({
                        title: 'Éxito!',
                        message: 'Solicitud cancelada correctamente',
                        type: 'success',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                }).catch((error) => {
                    Notification.error({
                        title: 'Error',
                        message: 'Error al cancelar la solicitud',
                        type: 'error',
                        duration: 3000,
                        customClass: 'notification-box',
                    });
                });
        }).catch((e) => {
            commit('setPreloader', false);
            console.error(e);
        });
    }
}

export async function downloadAttachment({commit}, attachment) {

    commit('setPreloader', true);

    await $http({
        url: '/api/solicitud-de-garantia/descargar-adjunto/' + attachment.id,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {

        commit('setPreloader', false);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachment.original_name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {

        commit('setPreloader', false);
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    });
}

export async function updateProductDocument({commit, state, dispatch, rootState}, product) {
    let data = JSON.parse(JSON.stringify(product));

    data.model_id = state.model.id;
    data.warehouse_id = state.request_guarantee.return.warehouse_id;
    data.branchoffice_id = state.request_guarantee.return.branchoffice_id;
    data.document_product_id = product.id;

    await $http.post('/api/items-carrito', data)
        .then(async response => {
            dispatch('updateDocumentValues');
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                Notification.error({
                    title: '¡Error!',
                    message: error.response.data.message,
                    type: 'error',
                    duration: 5000,
                    customClass: 'notification-box'
                });
            }
        });
}

export async function updateDocumentValues({commit, state}) {
    let data = {
        document_id: state.request_guarantee.return.id,
        model_id: state.model.id,
        warehouse_id: state.request_guarantee.return.warehouse_id
    };

    await $http
        .post('/api/documento/actualizar-valores/', data)
        .then(response => {
            commit('setUpdateDocumentValues', response.data);
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: '¡Error!',
                message: 'Error al actualizar los valores del documento.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchDocumentsByThread({commit, state}) {
    await $http
        .get('/api/back-order/' + state.request_guarantee.invoice_id)
        .then(response => {
            commit('setDocumentsByThread', response.data.data);
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: '¡Error!',
                message: 'Error al actualizar los valores del documento.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchModels({commit}) {
    commit('setPreloader', true);

    let params = {
        codes: ['155', '186']
    };

    await $http.get('/api/modelos-devoluciones', {params})
        .then((response) => {
            commit('setModels', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error',
                message: 'Error al obtener los modelos',
                type: 'error',
                duration: 3000,
                customClass: 'notification-box',
            });
        });
}



// WEBPACK FOOTER //
// ./src/b2b/modules/guarantees/actions.js